










import { defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    href: {
      type: String as PropType<string>,
      default: '',
    },
  },
});
